import { CallEmsApi, iEmsApiResponseBody } from "./FetchExtension";

export interface MailboxAccessRequestDTO {
    firstName: string;
    lastName: string;
    budgetCentre: string;
    departmentId: number;
    legacyId: string;
    RoleId: number;
    mailboxId: number;
    shiftLength: number;
    telephoneNumber: string;
    emailAddress: string;
    mobileNumber: string;
    businessTitle: string;
    motivation: string;
}

export interface CreateMailboxAccessRequestRequest {
    UserID: number;
    MailboxID: number;
    MotivationComment: string | null;
    RoleID: number;
    NotificationEmailAddress: string;
}

export async function CreateMailboxAccessRequest(
    request: CreateMailboxAccessRequestRequest,
): Promise<iEmsApiResponseBody<void>> {
    return await CallEmsApi<void>("POST", "MailboxAccessRequest", request);
}

export interface GetMailboxesResponse {
    items: MailboxList[];
}

export interface MailboxList {
    id: number;
    name: string;
    managerID: number;
    boxEnabled: boolean;
}

export async function GetMailboxes(): Promise<iEmsApiResponseBody<GetMailboxesResponse>> {
    const results = await CallEmsApi<GetMailboxesResponse>("GET", "Mailboxes");
    if (results.isOk && results.data) {
        results.data.items.sort((a, b) => {
            if (a.boxEnabled !== b.boxEnabled) {
                return a.boxEnabled ? -1 : 1;
            }
            return a.name.localeCompare(b.name);
        });
    }
    return results;
}

export interface GetMailboxRolesResponse {
    items: MailboxRolesListItemDTO[];
}

export interface MailboxRolesListItemDTO {
    id: number;
    name: string;
}

export async function GetMailboxRoles(): Promise<iEmsApiResponseBody<GetMailboxRolesResponse>> {
    return await CallEmsApi<GetMailboxRolesResponse>("GET", "MailboxRoles");
}

export interface GetDepartmentResponse {
    items: Departments[];
}

export interface Departments {
    id: number;
    name: string;
}

export async function GetDepartments(): Promise<iEmsApiResponseBody<GetDepartmentResponse>> {
    const results = await CallEmsApi<GetDepartmentResponse>("GET", `Departments`);
    if (results.isOk && results.data) {
        results.data.items.sort((a, b) => a.name.localeCompare(b.name));
    }
    return results;
}
